export default __webpack_public_path__ + "media/images/icons/dollar-sign-0c4fbf18813daec4f229e372b7724bf2.svg";